import { render, staticRenderFns } from "./advertiser-select.vue?vue&type=template&id=bc0c4258"
import script from "./advertiser-select.vue?vue&type=script&lang=js"
export * from "./advertiser-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports